export const SET_WINDOW_SIZE = "SET_WINDOW_SIZE";
